<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-row
          justify="center"
          align="center"
        >
          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <request-invite-card />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RequestInviteCard from "../components/RequestInviteCard"

export default {
  components: { RequestInviteCard },
}
</script>
